import { Alert, Box, ButtonBase, Paper, Stack, SvgIcon, Typography } from "@mui/material";
import { ChevronRight as ChevronRightIcon } from "@mui/icons-material";
import NavigationBar from "../../../../../utils/wizard/navigation";
import { useCreatableDocumentTypes } from "../../documentTypes";

const captionsByBasePath = {
  prescriptions: "Medicamentos",
  orders: "Prácticas, estudios y certificados",
};

const TypeOption = ({ module, isFirst, isSelected, onClick }) => (
  <ButtonBase
    onClick={onClick}
    sx={{
      width: "100%",
      justifyContent: "flex-start",
      textAlign: "left",
      px: 2.5,
      py: 2,
      gap: 2,
      borderTop: isFirst ? 0 : 1,
      borderColor: "divider",
      backgroundColor: isSelected ? "lightBlue.main" : "transparent",
      "&:hover": { backgroundColor: "lightBlue.main" },
    }}
  >
    <Box sx={{ display: "flex", p: 1, borderRadius: 2, backgroundColor: "lightBlue.main", color: "primary.main" }}>
      <module.Icon />
    </Box>
    <Stack flexGrow={1}>
      <Typography sx={{ fontWeight: 500 }}>{module.title}</Typography>
      <Typography variant="body2" color="grey.main">
        {captionsByBasePath[module.basePath]}
      </Typography>
    </Stack>
    <SvgIcon sx={{ color: "grey.main" }}>
      <ChevronRightIcon />
    </SvgIcon>
  </ButtonBase>
);

const MedicalDocumentTypeSelector = ({ modules, selectedBasePath, onSelect, ...props }) => {
  const creatableModules = useCreatableDocumentTypes(modules);

  const onTypeClick = (basePath) => {
    onSelect(basePath);
    props.nextStep();
  };

  return (
    <>
      <Typography variant="title" sx={{ display: "flex", justifyContent: "center", textAlign: "center" }}>
        ¿Qué querés crear?
      </Typography>
      {creatableModules.length === 0 ? (
        <Alert severity="info" sx={{ my: 3 }}>
          Tu cuenta no puede emitir recetas ni órdenes.
        </Alert>
      ) : (
        <Box sx={{ mt: 3, pb: { xs: 2, md: 6 } }}>
          <Paper variant="outlined" sx={{ borderRadius: 3, overflow: "hidden", maxWidth: 520, mx: "auto" }}>
            {creatableModules.map((module, index) => (
              <TypeOption
                key={module.basePath}
                module={module}
                isFirst={index === 0}
                isSelected={module.basePath === selectedBasePath}
                onClick={() => onTypeClick(module.basePath)}
              />
            ))}
          </Paper>
        </Box>
      )}
      <NavigationBar hideNext {...props} />
    </>
  );
};

export default MedicalDocumentTypeSelector;
